<template>
  <div class="qgen-filters">
    <el-input :model-value="modelValue.chapter" clearable placeholder="章节编号" class="qgen-filter-short" @change="update('chapter', $event)" />
    <el-select :model-value="modelValue.answer_source" clearable placeholder="答案来源" @change="update('answer_source', $event)">
      <el-option label="文档原答案" value="document" />
      <el-option label="AI 补全" value="ai_inferred" />
      <el-option label="教师修改" value="teacher" />
      <el-option label="缺少答案" value="missing" />
    </el-select>
    <el-select :model-value="modelValue.review_status" clearable placeholder="复核结论" @change="update('review_status', $event)">
      <el-option label="待复核" value="pending" />
      <el-option label="一致" value="agree" />
      <el-option label="冲突" value="conflict" />
      <el-option label="不确定" value="uncertain" />
      <el-option label="原答案存疑" value="source_conflict" />
      <el-option label="复核不可用" value="review_unavailable" />
      <el-option label="复核失败" value="failed" />
    </el-select>
    <el-select :model-value="modelValue.manual_status" clearable placeholder="人工状态" @change="update('manual_status', $event)">
      <el-option label="待确认" value="pending" />
      <el-option label="已确认" value="confirmed" />
      <el-option label="已跳过" value="skipped" />
    </el-select>
    <el-select :model-value="modelValue.risk" clearable placeholder="风险队列" @change="update('risk', $event)">
      <el-option label="低置信度" value="low_confidence" />
      <el-option label="法规风险" value="regulatory" />
      <el-option label="结构失败" value="structure_failure" />
      <el-option label="待人工确认" value="pending_manual" />
    </el-select>
    <el-button @click="reset">重置</el-button>
  </div>
</template>

<script setup>
const props = defineProps({ modelValue: { type: Object, required: true } })
const emit = defineEmits(['update:modelValue', 'change'])
const update = (field, value) => {
  const filters = { ...props.modelValue, [field]: value ?? '' }
  emit('update:modelValue', filters)
  emit('change', filters)
}
const reset = () => {
  const filters = { chapter: '', answer_source: '', review_status: '', manual_status: '', risk: '' }
  emit('update:modelValue', filters)
  emit('change', filters)
}
</script>

<style scoped>
.qgen-filters { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; }
.qgen-filters :deep(.el-select) { width: 150px; }
.qgen-filter-short { width: 110px; }
</style>
